import React, { useEffect } from "react";
import styles from "./CustomerSignUpFormWrapper.module.scss";
import { ButtonArrow } from "../../../assets/icons";
import FormProgressCircle from "../../../common/components/form-progress-circle/FormProgressCircle";
import { useSelector } from "react-redux";
import { BounceLoader } from "react-spinners";
import { currentStepSelector } from "../../../stores/slices/customer-registration-slice";
import FormStepHeader from "../../../common/components/form-step-header/FormStepHeader";

type Props = {
	title: string;
	subtitle: string;
	labelNext?: string;
	labelBack?: string;
	onNext: () => void;
	onBack: () => void;
	children?: React.ReactNode;
	nextButtonDisabled?: boolean;
	labelNextStep?: string
	labelBackStep?: string
	isLoading?: boolean;
};

const CustomerSignUpFormWrapper: React.FC<Props> = (props: Props) => {
	const { children, onNext, onBack, nextButtonDisabled, title, subtitle, isLoading, labelNext, labelBack, labelNextStep, labelBackStep } = props;

	const activeStep = useSelector(currentStepSelector);

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>{title}</h1>
			<h4 className={styles.subtitle}>{subtitle}</h4>
			<div className={styles.isNotMobile}>
				<FormProgressCircle numberOfSteps={4} activeStep={activeStep} />
			</div>
			<div className={styles.isMobile}>
				<FormStepHeader numberOfSteps={4} activeStep={activeStep} labelNextStep={labelNextStep} labelBackStep={labelBackStep} />
			</div>
			<div className={styles.content}>
				{children}
				<div className={`${styles.buttonContainer} ${styles.withContent}`}>
					<button className={`standardButton ${styles.button} ${styles.back}`} onClick={onBack}>
						<ButtonArrow />
						{labelBack ? labelBack : 'Back'}
					</button>
					<button className={`standardButton ${styles.button} ${styles.next}`} onClick={onNext} disabled={nextButtonDisabled || isLoading}>
						{isLoading ? (
							<BounceLoader color="#DE841B" size={25} />
						) : (
							<>
								{labelNext ? labelNext : 'Next'}
								<ButtonArrow />
							</>
						)}
					</button>
				</div>
			</div>
			<div className={`${styles.buttonContainer} ${styles.mobile}`}>
				<button className={`standardButton ${styles.button} ${styles.back}`} onClick={onBack}>
					<ButtonArrow />
					{labelBack ? labelBack : 'Back'}
				</button>
				<button className={`standardButton ${styles.button} ${styles.next}`} onClick={onNext} disabled={nextButtonDisabled || isLoading}>
					{isLoading ? (
						<BounceLoader color="#DE841B" size={25} />
					) : (
						<>
							{labelNext ? labelNext : 'Next'}
							<ButtonArrow />
						</>
					)}
				</button>
			</div>
		</div>
	);
};

export default CustomerSignUpFormWrapper;
